import { render, staticRenderFns } from "./IncorrectBalanceRedirect.vue?vue&type=template&id=08430d9b&"
import script from "./IncorrectBalanceRedirect.vue?vue&type=script&lang=js&"
export * from "./IncorrectBalanceRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports